// 事件
import EventEmitter from 'events'
const emit = new EventEmitter(); 
export { emit };